module.exports = __webpack_public_path__ + "img/dish4.6a9ec6ba.png";